import productosService from './productos.service';

/**
 * Alta rápida desde cajero (sin ir a pantalla Productos).
 */
export async function crearProductoRapidoPos({
  codigo,
  nombre,
  categoria = '',
  precioVenta,
  cargarStock = false,
  stockInicial = 0,
  sucursalId,
  manualWeight = false,
  weightType = null,
  tipoVenta = 'unidad',
  precioPorKg = null,
  categoriaPeso = null,
  codigoManual = null
}) {
  const precio = parseFloat(String(precioVenta).replace(',', '.'));
  if (Number.isNaN(precio) || precio <= 0) {
    throw new Error('El precio debe ser mayor a 0');
  }
  const stock = cargarStock ? Math.max(0, parseInt(stockInicial, 10) || 0) : 0;
  const vendidoPorPeso = manualWeight === true;
  const tipoFinal = vendidoPorPeso ? 'peso_manual' : 'unidad';
  const payload = {
    codigo: String(codigo || '').trim(),
    codigo_barras: String(codigo || '').trim(),
    nombre: String(nombre || '').trim(),
    descripcion: categoria ? `Categoría: ${categoria}` : '',
    precio_venta: precio,
    precio_costo: 0,
    stock_actual: stock,
    stock_inicial: stock,
    stock_minimo: 5,
    sucursal_id: sucursalId,
    activo: true,
    manualWeight: vendidoPorPeso,
    manual_weight: vendidoPorPeso,
    unidad_medida: vendidoPorPeso ? 'kg' : 'unidad',
    tipoVenta: tipoFinal,
    tipo_venta: tipoFinal
  };
  if (vendidoPorPeso) {
    payload.weightType = weightType || categoriaPeso || 'granel';
    payload.precioPorKg = Number(precioPorKg) > 0 ? Number(precioPorKg) : precio;
    payload.precio_por_kg = payload.precioPorKg;
    payload.categoriaPeso = categoriaPeso || payload.weightType || 'granel';
    payload.codigoManual = codigoManual || payload.codigo;
  }
  const res = await productosService.crear(payload);
  const data = res?.data?.data || res?.data || res;
  return { id: data?.id, ...data, ...payload };
}
